import { useTrialStatus } from '@/hooks/useBillingTrial';
import { X, Sparkles } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function TrialBanner() {
  const { data: trial, isLoading } = useTrialStatus();
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  if (isLoading || dismissed || !trial) return null;

  // Don't show banner if user has paid plan or isn't trialing
  if (trial.hasPaidPlan || (!trial.isTrialing && !trial.isExpired)) return null;

  if (trial.isExpired) {
    return (
      <div className="bg-red-600 text-white px-4 py-2 flex items-center justify-between text-sm">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4" />
          <span>
            Your free trial has expired. Upgrade to continue using all features.
          </span>
        </div>
        <button
          onClick={() => navigate('/settings/billing')}
          className="px-3 py-1 bg-white text-red-600 rounded text-xs font-semibold hover:bg-red-50"
        >
          Upgrade now
        </button>
      </div>
    );
  }

  if (trial.isTrialing) {
    const urgency = trial.daysRemaining <= 3;

    return (
      <div className={`${urgency ? 'bg-amber-500' : 'bg-indigo-600'} text-white px-4 py-2 flex items-center justify-between text-sm`}>
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4" />
          <span>
            {trial.daysRemaining} day{trial.daysRemaining !== 1 ? 's' : ''} left in your free trial.
            {urgency ? ' Upgrade now to keep all features.' : ''}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate('/settings/billing')}
            className="px-3 py-1 bg-white text-indigo-600 rounded text-xs font-semibold hover:bg-indigo-50"
          >
            Upgrade
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="p-0.5 hover:bg-white/20 rounded"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    );
  }

  return null;
}
